import { render, staticRenderFns } from "./images-box.vue?vue&type=template&id=03362dee&scoped=true&"
import script from "./images-box.vue?vue&type=script&lang=ts&"
export * from "./images-box.vue?vue&type=script&lang=ts&"
import style0 from "./images-box.vue?vue&type=style&index=0&id=03362dee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03362dee",
  null
  
)

export default component.exports